import { useNavigate } from "react-router-dom";
import Nav from "./Nav.jsx";
import Footer from "./Footer.jsx";
import "./home.css";
import StandardExpressList from "../Components/ListpageExpress";
import { fixedAssets } from "../HelperFx/datalinks.js";
import verifyToken from "../HelperFx/verifyJwt.js";

const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;
const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;
const REACT_APP_COMPANY_URL = process.env.REACT_APP_COMPANY;

const CustomerInventoryList = () => {
  const navigate = useNavigate();
  const token = btoa(`${REACT_UNAME}:${REACT_PWD}`);
  const { custName } = verifyToken(sessionStorage.getItem("authToken")) || {};
  const apiUrl = `${REACT_DATA_URL}${fixedAssets}?${REACT_APP_COMPANY_URL}&$filter=customerNo eq '${custName}'`;

  const columns = [
    {
      name: "No.",
      selector: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
          onClick={() =>
            navigate("/CustomerInventory", { state: { number: row.no } })
          }
        >
          {row.no}
        </span>
      ),
      sortable: true,
    },
    { name: "Name", selector: (row) => row.description, sortable: true },
    {
      name: "Fixed Asset Class",
      selector: (row) => row.fAClassCode,
      sortable: true,
    },
    {
      name: "Fixed Asset SubClass",
      selector: (row) => row.fASubclassCode,
      sortable: true,
    },
    { name: "Serial No.", selector: (row) => row.serialNumber, sortable: true },
    { name: "Engrave No.", selector: (row) => row.engraveNo, sortable: true },
  ];

  return (
    <div className="Home">
      <Nav />
      <div className="dash-main settings-full">
        <StandardExpressList
          apiUrl={apiUrl}
          token={token}
          columns={columns}
          searchKeys={["no", "description", "fAClassCode", "serialNumber", "engraveNo"]}
          pageCaption="Customer Inventory List"
          actionvisibility={false}
          redirectTo="home"
          infiniteScroll
        />
      </div>
      <Footer />
    </div>
  );
};

export default CustomerInventoryList;
